import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCanContractBenefits } from '../../hooks/useCanContractBenefits';
export function PersonJuridicaGuard({ children, redirectTo = '/beneficios/person-hiring-blocked', }) {
    const { isPersonFisica, isPersonJuridica, isLoading } = useCanContractBenefits();
    if (isLoading) {
        return null;
    }
    if (isPersonFisica) {
        return _jsx(Navigate, { to: redirectTo, replace: true });
    }
    if (isPersonJuridica) {
        return _jsx(_Fragment, { children: children });
    }
    return _jsx(Navigate, { to: redirectTo, replace: true });
}
